import { render, staticRenderFns } from "./jobContent.vue?vue&type=template&id=1849508c&scoped=true"
import script from "./jobContent.vue?vue&type=script&lang=js"
export * from "./jobContent.vue?vue&type=script&lang=js"
import style0 from "./jobContent.vue?vue&type=style&index=0&id=1849508c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1849508c",
  null
  
)

export default component.exports